"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var AddressResultRow = function (_a) {
    var result = _a.result, i = _a.i, findOrRetrieve = _a.findOrRetrieve, trackAddress = _a.trackAddress, hideResults = _a.hideResults, setResultClicked = _a.setResultClicked;
    var canClick = false;
    var enableClick = function () {
        canClick = true;
    };
    var handleClick = function (e) {
        e.preventDefault();
        if (canClick) {
            setResultClicked(true);
            findOrRetrieve(result);
            trackAddress(result);
        }
    };
    var handleKeyDown = function (event) {
        var keyName = event.key;
        switch (keyName) {
            case 'Enter':
            case ' ':
                findOrRetrieve(result);
                event.preventDefault();
                trackAddress(result);
                break;
            case 'Escape':
                hideResults();
                break;
        }
    };
    var handleOnBlur = function (event) {
        if (event.relatedTarget && event.relatedTarget.getAttribute('id').match(/address-result-\d+/)) {
            return;
        }
        hideResults();
    };
    var className = 'result-row small';
    var id = "address-result-" + i;
    return (React.createElement("div", { className: className, key: i },
        React.createElement("input", { id: id, onClick: handleClick, onKeyDown: handleKeyDown, type: 'radio', onBlur: handleOnBlur }),
        React.createElement("label", { htmlFor: id, onMouseUp: enableClick }, result.Text)));
};
exports.default = AddressResultRow;
